// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDaHLMlToAWIg5DcLD5ZN5PIYWzlU6wSRc",
    authDomain: "demoproject-1f866.firebaseapp.com",
    databaseURL: "https://demoproject-1f866.firebaseio.com",
    projectId: "demoproject-1f866",
    storageBucket: "demoproject-1f866.appspot.com",
    messagingSenderId: "331647175493",
    appId: "1:331647175493:web:82a2dd975c45836d434c2c"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
